var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',[_c('CCard',[_c('CCardHeader',[_vm._v("訊息")]),_c('CCardBody',[_vm._v("歡迎使用安特資訊進銷存系統，請由左方選單進入系統。")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }